export default __webpack_public_path__ + "static/media/video-call.eaea66ee.png";